const PAYS_OPTIONS = [
{ "id": 1, "value": "La France", "text": "France", "code": "250" },
{ "id": 2, "value": "L'Afghanistan", "text": "Afghanistan", "code": "004" },
{ "id": 3, "value": "L'Afrique du Sud", "text": "Afrique du Sud", "code": "710" },
{ "id": 4, "value": "L'Albanie", "text": "Albanie", "code": "008" },
{ "id": 5, "value": "L'Algérie", "text": "Algérie", "code": "012" },
{ "id": 6, "value": "L'Allemagne", "text": "Allemagne", "code": "276" },
{ "id": 7, "value": "L'Andorre", "text": "Andorre", "code": "020" },
{ "id": 8, "value": "L'Angola", "text": "Angola", "code": "024" },
{ "id": 9, "value": "L'Antigua-et-Barbuda", "text": "Antigua-et-Barbuda", "code": "028" },
{ "id": 10, "value": "L'Arabie Saoudite", "text": "Arabie Saoudite", "code": "682" },
{ "id": 11, "value": "L'Argentine", "text": "Argentine", "code": "032" },
{ "id": 12, "value": "L'Arménie", "text": "Arménie", "code": "051" },
{ "id": 13, "value": "Aruba", "text": "Aruba", "code": "533" },
{ "id": 14, "value": "L'Australie", "text": "Australie", "code": "036" },
{ "id": 15, "value": "L'Autriche", "text": "Autriche", "code": "040" },
{ "id": 16, "value": "L'Azerbaïdjan", "text": "Azerbaïdjan", "code": "031" },
{ "id": 17, "value": "Les Bahamas", "text": "Bahamas", "code": "044" },
{ "id": 18, "value": "Bahreïn", "text": "Bahreïn", "code": "048" },
{ "id": 19, "value": "Le Bangladesh", "text": "Bangladesh", "code": "050" },
{ "id": 20, "value": "La Barbade", "text": "Barbade", "code": "052" },
{ "id": 21, "value": "La Biélorussie / Le Bélarus", "text": "Biélorussie / Bélarus", "code": "112" },
{ "id": 22, "value": "La Birmanie", "text": "Birmanie", "code": "104" },
{ "id": 23, "value": "La Belgique", "text": "Belgique", "code": "056" },
{ "id": 24, "value": "Le Belize", "text": "Belize", "code": "084" },
{ "id": 25, "value": "Le Bénin", "text": "Bénin", "code": "204" },
{ "id": 26, "value": "Les Bermudes", "text": "Bermudes", "code": "060" },
{ "id": 27, "value": "Le Bhoutan", "text": "Bhoutan", "code": "064" },
{ "id": 28, "value": "La Bolivie", "text": "Bolivie", "code": "068" },
{ "id": 29, "value": "La Bosnie-Herzégovine", "text": "Bosnie-Herzégovine", "code": "070" },
{ "id": 30, "value": "Le Botswana", "text": "Botswana", "code": "072" },
{ "id": 31, "value": "Le Brésil", "text": "Brésil", "code": "076" },
{ "id": 32, "value": "Le Brunéi", "text": "Brunéi", "code": "096" },
{ "id": 33, "value": "La Bulgarie", "text": "Bulgarie", "code": "100" },
{ "id": 34, "value": "Le Burkina Faso", "text": "Burkina Faso", "code": "854" },
{ "id": 35, "value": "Le Burundi", "text": "Burundi", "code": "108" },
{ "id": 36, "value": "Le Cambodge", "text": "Cambodge", "code": "116" },
{ "id": 37, "value": "Le Cameroun", "text": "Cameroun", "code": "120" },
{ "id": 38, "value": "Le Canada", "text": "Canada", "code": "124" },
{ "id": 39, "value": "Le Cap-Vert", "text": "Cap-Vert", "code": "132" },
{ "id": 40, "value": "La Rép. centrafricaine", "text": "Rép. centrafricaine", "code": "140" },
{ "id": 41, "value": "Le Chili", "text": "Chili", "code": "152" },
{ "id": 42, "value": "La Chine", "text": "Chine", "code": "156" },
{ "id": 43, "value": "Chypre", "text": "Chypre", "code": "196" },
{ "id": 44, "value": "La Colombie", "text": "Colombie", "code": "170" },
{ "id": 45, "value": "Les Comores", "text": "Comores", "code": "174" },
{ "id": 46, "value": "La Rép. du Congo", "text": "Rép. du Congo", "code": "178" },
{ "id": 47, "value": "La Rép. dém. du Congo", "text": "Rép. dém. du Congo", "code": "180" },
{ "id": 48, "value": "La Corée du Nord", "text": "Corée du Nord", "code": "408" },
{ "id": 49, "value": "La Corée du Sud", "text": "Corée du Sud", "code": "410" },
{ "id": 50, "value": "Le Costa Rica", "text": "Costa Rica", "code": "188" },
{ "id": 51, "value": "La Côte d’Ivoire", "text": "Côte d’Ivoire", "code": "384" },
{ "id": 52, "value": "La Croatie", "text": "Croatie", "code": "191" },
{ "id": 53, "value": "Cuba", "text": "Cuba", "code": "192" },
{ "id": 54, "value": "Le Danemark", "text": "Danemark", "code": "208" },
{ "id": 55, "value": "La Dominique", "text": "Dominique", "code": "212" },
{ "id": 56, "value": "Djibouti", "text": "Djibouti", "code": "262" },
{ "id": 57, "value": "L'Égypte", "text": "Égypte", "code": "818" },
{ "id": 58, "value": "Les Émirats arabes unis", "text": "Émirats arabes unis", "code": "784" },
{ "id": 59, "value": "L'Équateur", "text": "Équateur", "code": "218" },
{ "id": 60, "value": "L'Érythrée", "text": "Érythrée", "code": "232" },
{ "id": 61, "value": "L'Espagne", "text": "Espagne", "code": "724" },
{ "id": 62, "value": "L'Estonie", "text": "Estonie", "code": "233" },
{ "id": 63, "value": "Les États-Unis", "text": "États-Unis", "code": "840" },
{ "id": 64, "value": "L'Éthiopie", "text": "Éthiopie", "code": "231" },
{ "id": 65, "value": "Les Fidji", "text": "Fidji", "code": "242" },
{ "id": 66, "value": "La Finlande", "text": "Finlande", "code": "246" },
{ "id": 67, "value": "Le Gabon", "text": "Gabon", "code": "266" },
{ "id": 68, "value": "La Gambie", "text": "Gambie", "code": "270" },
{ "id": 69, "value": "La Géorgie", "text": "Géorgie", "code": "268" },
{ "id": 70, "value": "Le Ghana", "text": "Ghana", "code": "288" },
{ "id": 71, "value": "Gibraltar", "text": "Gibraltar", "code": "292" },
{ "id": 72, "value": "La Grèce", "text": "Grèce", "code": "300" },
{ "id": 73, "value": "Grenade", "text": "Grenade", "code": "308" },
{ "id": 74, "value": "Le Guatemala", "text": "Guatemala", "code": "320" },
{ "id": 75, "value": "Guernesey", "text": "Guernesey", "code": "831" },
{ "id": 76, "value": "La Guinée", "text": "Guinée", "code": "324" },
{ "id": 77, "value": "La Guinée-Bissau", "text": "Guinée-Bissau", "code": "624" },
{ "id": 78, "value": "La Guinée équatoriale", "text": "Guinée équatoriale", "code": "226" },
{ "id": 79, "value": "Le Guyana", "text": "Guyana", "code": "328" },
{ "id": 80, "value": "Haïti", "text": "Haïti", "code": "332" },
{ "id": 81, "value": "Le Honduras", "text": "Honduras", "code": "340" },
{ "id": 82, "value": "La Hongrie", "text": "Hongrie", "code": "348" },
{ "id": 83, "value": "L'Inde", "text": "Inde", "code": "356" },
{ "id": 84, "value": "L'Indonésie", "text": "Indonésie", "code": "360" },
{ "id": 85, "value": "L'Iran", "text": "Iran", "code": "364" },
{ "id": 86, "value": "L'Irak", "text": "Irak", "code": "368" },
{ "id": 87, "value": "L'Irlande", "text": "Irlande", "code": "372" },
{ "id": 88, "value": "L'Islande", "text": "Islande", "code": "352" },
{ "id": 89, "value": "Israël", "text": "Israël", "code": "376" },
{ "id": 90, "value": "L'Italie", "text": "Italie", "code": "380" },
{ "id": 91, "value": "La Jamaïque", "text": "Jamaïque", "code": "388" },
{ "id": 92, "value": "Le Japon", "text": "Japon", "code": "392" },
{ "id": 93, "value": "La Jordanie", "text": "Jordanie", "code": "400" },
{ "id": 94, "value": "Le Kazakhstan", "text": "Kazakhstan", "code": "398" },
{ "id": 95, "value": "Le Kenya", "text": "Kenya", "code": "404" },
{ "id": 96, "value": "Le Kirghizistan", "text": "Kirghizistan", "code": "417" },
{ "id": 97, "value": "Les Kiribati", "text": "Kiribati", "code": "296" },
{ "id": 98, "value": "Le Koweït", "text": "Koweït", "code": "414" },
{ "id": 99, "value": "Le Kosovo", "text": "Kosovo", "code": "0" },
{ "id": 100, "value": "Le Laos", "text": "Laos", "code": "418" },
{ "id": 101, "value": "Le Lesotho", "text": "Lesotho", "code": "426" },
{ "id": 102, "value": "La Lettonie", "text": "Lettonie", "code": "428" },
{ "id": 103, "value": "Le Liban", "text": "Liban", "code": "422" },
{ "id": 104, "value": "Le Libéria", "text": "Libéria", "code": "430" },
{ "id": 105, "value": "La Libye", "text": "Libye", "code": "434" },
{ "id": 106, "value": "Le Liechtenstein", "text": "Liechtenstein", "code": "438" },
{ "id": 107, "value": "La Lituanie", "text": "Lituanie", "code": "440" },
{ "id": 108, "value": "Le Luxembourg", "text": "Luxembourg", "code": "442" },
{ "id": 109, "value": "La Macédoine", "text": "Macédoine", "code": "807" },
{ "id": 110, "value": "Madagascar", "text": "Madagascar", "code": "450" },
{ "id": 111, "value": "La Malaisie", "text": "Malaisie", "code": "458" },
{ "id": 112, "value": "Le Malawi", "text": "Malawi", "code": "454" },
{ "id": 113, "value": "Les Maldives", "text": "Maldives", "code": "462" },
{ "id": 114, "value": "Le Mali", "text": "Mali", "code": "466" },
{ "id": 115, "value": "Malte", "text": "Malte", "code": "470" },
{ "id": 116, "value": "Les Îles Marshall", "text": "Îles Marshall", "code": "584" },
{ "id": 117, "value": "Le Maroc", "text": "Maroc", "code": "504" },
{ "id": 118, "value": "Maurice", "text": "Maurice", "code": "480" },
{ "id": 119, "value": "La Mauritanie", "text": "Mauritanie", "code": "478" },
{ "id": 120, "value": "Le Mexique", "text": "Mexique", "code": "484" },
{ "id": 121, "value": "La Moldavie", "text": "Moldavie", "code": "498" },
{ "id": 122, "value": "Monaco", "text": "Monaco", "code": "492" },
{ "id": 123, "value": "La Mongolie", "text": "Mongolie", "code": "496" },
{ "id": 124, "value": "Le Monténégro", "text": "Monténégro", "code": "499" },
{ "id": 125, "value": "Le Mozambique", "text": "Mozambique", "code": "508" },
{ "id": 126, "value": "La Namibie", "text": "Namibie", "code": "516" },
{ "id": 127, "value": "Nauru", "text": "Nauru", "code": "520" },
{ "id": 128, "value": "Le Népal", "text": "Népal", "code": "524" },
{ "id": 129, "value": "Le Nicaragua", "text": "Nicaragua", "code": "558" },
{ "id": 130, "value": "Le Niger", "text": "Niger", "code": "562" },
{ "id": 131, "value": "Le Nigéria", "text": "Nigéria", "code": "566" },
{ "id": 132, "value": "Niué", "text": "Niué", "code": "570" },
{ "id": 133, "value": "La Norvège", "text": "Norvège", "code": "578" },
{ "id": 134, "value": "La Nouvelle-Zélande", "text": "Nouvelle-Zélande", "code": "554" },
{ "id": 135, "value": "Oman", "text": "Oman", "code": "512" },
{ "id": 136, "value": "L'Ouganda", "text": "Ouganda", "code": "800" },
{ "id": 137, "value": "L'Ouzbékistan", "text": "Ouzbékistan", "code": "860" },
{ "id": 138, "value": "Le Pakistan", "text": "Pakistan", "code": "586" },
{ "id": 139, "value": "Le Palaos", "text": "Palaos", "code": "585" },
{ "id": 140, "value": "Le Panama", "text": "Panama", "code": "591" },
{ "id": 141, "value": "LaPapouasie-Nouvelle-Guinée", "text": "Papouasie-Nouvelle-Guinée", "code": "598" },
{ "id": 142, "value": "Le Paraguay", "text": "Paraguay", "code": "600" },
{ "id": 143, "value": "Les Pays-Bas", "text": "Pays-Bas", "code": "528" },
{ "id": 144, "value": "Le Pérou", "text": "Pérou", "code": "604" },
{ "id": 145, "value": "Les Philippines", "text": "Philippines", "code": "608" },
{ "id": 146, "value": "La Pologne", "text": "Pologne", "code": "616" },
{ "id": 147, "value": "Porto Rico", "text": "Porto Rico", "code": "630" },
{ "id": 148, "value": "Le Portugal", "text": "Portugal", "code": "620" },
{ "id": 149, "value": "Le Qatar", "text": "Qatar", "code": "634" },
{ "id": 150, "value": "La République dominicaine", "text": "République dominicaine", "code": "214" },
{ "id": 151, "value": "La République tchèque", "text": "République tchèque", "code": "203" },
{ "id": 152, "value": "La Roumanie", "text": "Roumanie", "code": "642" },
{ "id": 153, "value": "Le Royaume-Uni", "text": "Royaume-Uni", "code": "826" },
{ "id": 154, "value": "La Russie", "text": "Russie", "code": "643" },
{ "id": 155, "value": "Le Rwanda", "text": "Rwanda", "code": "646" },
{ "id": 156, "value": "St-Christophe-et-Niévès", "text": "St-Christophe-et-Niévès", "code": "659" },
{ "id": 157, "value": "St-Lucie", "text": "St-Lucie", "code": "662" },
{ "id": 158, "value": "St-Vincent-et-les-Grenadines", "text": "St-Vincent-et-les-Grenadines", "code": "670" },
{ "id": 159, "value": "Saint-Marin", "text": "Saint-Marin", "code": "674" },
{ "id": 160, "value": "Samoa", "text": "Samoa", "code": "882" },
{ "id": 161, "value": "Sao Tomé-et-Principe", "text": "Sao Tomé-et-Principe", "code": "678" },
{ "id": 162, "value": "Le Salvador", "text": "Salvador", "code": "222" },
{ "id": 163, "value": "Le Sénégal", "text": "Sénégal", "code": "686" },
{ "id": 164, "value": "La Serbie", "text": "Serbie", "code": "688" },
{ "id": 165, "value": "Les Seychelles", "text": "Seychelles", "code": "690" },
{ "id": 166, "value": "Le Sierra Leone", "text": "Sierra Leone", "code": "694" },
{ "id": 167, "value": "Singapour", "text": "Singapour", "code": "702" },
{ "id": 168, "value": "La Slovaquie", "text": "Slovaquie", "code": "703" },
{ "id": 169, "value": "La Slovénie", "text": "Slovénie", "code": "705" },
{ "id": 170, "value": "Les Îles Salomon", "text": "Îles Salomon", "code": "090" },
{ "id": 171, "value": "La Somalie", "text": "Somalie", "code": "706" },
{ "id": 172, "value": "Le Soudan", "text": "Soudan", "code": "729" },
{ "id": 173, "value": "Le Soudan du Sud", "text": "Soudan du Sud", "code": "728" },
{ "id": 174, "value": "Le Sri Lanka", "text": "Sri Lanka", "code": "144" },
{ "id": 175, "value": "La Suède", "text": "Suède", "code": "752" },
{ "id": 176, "value": "La Suisse", "text": "Suisse", "code": "756" },
{ "id": 177, "value": "Le Surinam", "text": "Surinam", "code": "740" },
{ "id": 178, "value": "Le Swaziland", "text": "Swaziland", "code": "748" },
{ "id": 179, "value": "La Syrie", "text": "Syrie", "code": "760" },
{ "id": 180, "value": "Le Tadjikistan", "text": "Tadjikistan", "code": "762" },
{ "id": 181, "value": "Taïwan", "text": "Taïwan", "code": "158" },
{ "id": 182, "value": "La Tanzanie", "text": "Tanzanie", "code": "834" },
{ "id": 183, "value": "Le Tchad", "text": "Tchad", "code": "148" },
{ "id": 184, "value": "La Thaïlande", "text": "Thaïlande", "code": "764" },
{ "id": 185, "value": "Le Timor-Oriental", "text": "Timor-Oriental", "code": "626" },
{ "id": 186, "value": "Le Togo", "text": "Togo", "code": "768" },
{ "id": 187, "value": "Le Tonga", "text": "Tonga", "code": "776" },
{ "id": 188, "value": "Le Trinité-et-Tobago", "text": "Trinité-et-Tobago", "code": "780" },
{ "id": 189, "value": "La Tunisie", "text": "Tunisie", "code": "788" },
{ "id": 190, "value": "Le Turkménistan", "text": "Turkménistan", "code": "795" },
{ "id": 191, "value": "La Turquie", "text": "Turquie", "code": "792" },
{ "id": 192, "value": "Les Tuvalu", "text": "Tuvalu", "code": "798" },
{ "id": 193, "value": "L'Ukraine", "text": "Ukraine", "code": "804" },
{ "id": 194, "value": "L'Uruguay", "text": "Uruguay", "code": "858" },
{ "id": 195, "value": "Uzbekistan", "text": "Uzbekistan", "code": "860" },
{ "id": 196, "value": "Le Vanuatu", "text": "Vanuatu", "code": "548" },
{ "id": 197, "value": "Le Venezuela", "text": "Venezuela", "code": "862" },
{ "id": 198, "value": "Le Vietnam", "text": "Vietnam", "code": "704" },
{ "id": 199, "value": "Le Yémen", "text": "Yémen", "code": "887" },
{ "id": 200, "value": "La Zambie", "text": "Zambie", "code": "894" },
{ "id": 201, "value": "Le Zimbabwe", "text": "Zimbabwe", "code": "716" },
{ "id": 202, "value": "Autre", "text": "Autre", "code": "999" }
];

export default PAYS_OPTIONS;
